export const APP_PATH = '/app';

export const AUTH_PATH = '/auth';

export const DEFAULT_PATH = '/app/dashboard';

export const DATE_TIME_FORMAT = 'yyyy/MM/DD hh:mm';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIMEZONE = 'UTC';
